import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import { Dialog } from "../../types";

const batchSectionUrl = "/payout/batch";

export const batchListPath = batchSectionUrl;

export const batchPath = (id: string) => urlJoin(batchSectionUrl, id);

export type BatchListUrlDialog =
  | "approve"
  | "cancel"
  | "download-active-batch"
  | "reject"
  | "FnManagerdowloadActiveDetails"
  | "FnManagerGeneratePayableList";

export type BatchListUrlQueryParams = Dialog<BatchListUrlDialog>;

export const batchListUrl = (params?: BatchListUrlQueryParams): string => {
  const batchList = batchListPath;

  return urlJoin(batchList, "?" + stringifyQs(params));
};

export const batchDetailsUrl = (id: string, params?: BatchListUrlQueryParams) =>
  batchPath(id) + "?" + stringifyQs(params);
